import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Button, { ButtonProps } from "@material-ui/core/Button";

import styles from "assets/jss/elite-feats-cms/components/buttonStyle";

const useStyles = makeStyles(styles);

interface RegularButtonProps extends Omit<ButtonProps, "color" | "size" | "classes"> {
  color?:
    | "primary"
    | "info"
    | "success"
    | "warning"
    | "danger"
    | "rose"
    | "white"
    | "twitter"
    | "facebook"
    | "google"
    | "linkedin"
    | "pinterest"
    | "youtube"
    | "tumblr"
    | "darkBlue"
    | "github"
    | "behance"
    | "dribbble"
    | "reddit"
    | "transparent"
    | "default"
    | "modules"
    | "toolsOne"
    | "toolsTwo"
    | "toolsThree"
    | "toolsFour"
    | "toolsFive"
    | "tool1"
    | "tool2"
    | "tool3"
    | "tool4"
    | "tool5";
  size?: "sm" | "md" | "lg";
  simple?: boolean;
  round?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  block?: boolean;
  link?: boolean;
  justIcon?: boolean;
  className?: string;
  muiClasses?: ButtonProps["classes"];
  href?: string;
  target?: string;
  children?: React.ReactNode;
}

const RegularButton = React.forwardRef<HTMLButtonElement, RegularButtonProps>(
  (props, ref) => {
    const classes = useStyles();
    const {
      color,
      round,
      children,
      fullWidth,
      disabled,
      simple,
      size,
      block,
      link,
      justIcon,
      className,
      muiClasses,
      ...rest
    } = props;
    const btnClasses = classNames({
      [classes.button]: true,
      [classes[size as string]]: size,
      [classes[color as string]]: color,
      [classes.round]: round,
      [classes.fullWidth]: fullWidth,
      [classes.disabled]: disabled,
      [classes.simple]: simple,
      [classes.block]: block,
      [classes.link]: link,
      [classes.justIcon]: justIcon,
      [className as string]: className,
    });
    return (
      <Button {...rest} ref={ref} classes={muiClasses} className={btnClasses}>
        {children}
      </Button>
    );
  }
);

export default RegularButton;
